import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useComments(data = {}) {
  const { enabled = false, hashID, configs = {} } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getComments() {
    return privateFetch.get(`/v1/admin/comments/${hashID}`, configs).then((res) => res.data);
  }

  return useQuery(['content-comments', { data }], getComments, { enabled });
}

export default useComments;
